/**
 * Stores all the types constants.
 * Will be later used to call these actions or look into their results.
 * */

export const GET_FACULTIES = 'GET_FACULTIES'
export const SET_FACULTY = 'SET_FACULTY'
export const GET_SEMESTERS = 'GET_SEMESTERS'
export const SET_SEMESTER = 'SET_SEMESTER'
export const GET_COURSES = 'GET_COURSES'
export const SET_COURSE = 'SET_COURSE'
export const GET_LECTURES = 'GET_LECTURES'
export const SET_LECTURE = 'SET_LECTURE'
export const GET_STUDY_SEMESTERS = 'GET_STUDY_SEMESTERS'
export const SET_STUDY_SEMESTER = 'SET_STUDY_SEMESTER'
export const GET_DESIGN_FACULTY_DATA = 'GET_DESIGN_FACULTY_DATA'
export const SET_DESIGN_FACULTY_SEGMENTS = 'SET_DESIGN_FACULTY_SEGMENTS'
export const SET_DESIGN_FACULTY_SEGMENT = 'SET_DESIGN_FACULTY_SEGMENT'
export const RESET_SELECTION = 'RESET_SELECTION'
export const TOGGLE_LOADING = 'TOGGLE_LOADING'
export const SET_CACHE_STATUS = 'SET_CACHE_STATUS'
